import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { fetchFeeCategories, createFeeCategory } from "../service/feeCategoryService";
import type { FeeCategory, CreateFeeCategoryPayload } from "../types";

export const loadFeeCategories = createAsyncThunk("feeCategories/loadFeeCategories", async () => {
  return fetchFeeCategories();
});

export const addFeeCategory = createAsyncThunk(
  "feeCategories/addFeeCategory",
  async (payload: CreateFeeCategoryPayload) => createFeeCategory(payload)
);

interface FeeCategoryState {
  categories: FeeCategory[];
  knownFlagKeys: string[];
  loading: boolean;
  loaded: boolean;
  error: string | null;
}

const initialState: FeeCategoryState = {
  categories: [],
  knownFlagKeys: [],
  loading: false,
  loaded: false,
  error: null,
};

const feeCategorySlice = createSlice({
  name: "feeCategories",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(loadFeeCategories.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(loadFeeCategories.fulfilled, (state, action) => {
        state.loading = false;
        state.loaded = true;
        state.categories = action.payload.categories;
        state.knownFlagKeys = action.payload.knownFlagKeys;
      })
      .addCase(loadFeeCategories.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message ?? "Failed to load fee categories";
      })
      .addCase(addFeeCategory.fulfilled, (state, action) => {
        state.categories.push(action.payload);
      })
      .addCase(addFeeCategory.rejected, (state, action) => {
        state.error = action.error.message ?? "Failed to add fee category";
      });
  },
});

export default feeCategorySlice.reducer;
